module.exports = __webpack_public_path__ + "static/media/hamburger~bnuqweWD.c47449f4.svg";